export const CrossIcon = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.94356 5.00026L9.47211 8.52881L8.5293 9.47162L5.00075 5.94307L1.47221 9.47162L0.529397 8.52881L4.05794 5.00026L0.529297 1.47162L1.47211 0.528809L5.00075 4.05745L8.5294 0.528809L9.47221 1.47162L5.94356 5.00026Z" />
    </svg>
  )
}
